<template lang="pug">
.new-address-container(v-if="memberInfo.id")
    van-form(:form="memberInfo" layout="vertical" @submit="confirm")
        van-field(
            label="姓"
            name='personName.lastName'
            v-model="memberInfo.personName.lastName"
            :rules="[{ required: true, message: '请输入姓' }]"
            placeholder="请输入姓")
        van-field(
            label="名"
            name='personName.firstName'
            v-model="memberInfo.personName.firstName"
            :rules="[{ required: true, message: '请输入名' }]"
            placeholder="请输入名")
        van-field(
            label="手机"
            name='phone'
            v-model="memberInfo.phone"
            :rules="[{ validator: validatePhone,message: '请输入正确手机号' }]"
            placeholder="请输入手机号")
        van-field(
            label="邮箱"
            name='mailbox'
            v-model="memberInfo.mailbox"
            :rules="[{ validator:validateMail,message: '请输入正确邮箱' }]"
            placeholder="请输入邮箱")
        van-field(
            label="公司"
            name='company'
            v-model="memberInfo.company"
            :rules="[{  required: true,message: '请输入公司' }]"
            placeholder="请输入公司")
        van-field(
            label="职位"
            name='position'
            v-model="memberInfo.position"
            :rules="[{  required: true,message: '请输入职位' }]"
            placeholder="请输入职位")
        van-field(
            label="行业"
            name='industry'
            v-model="memberInfo.industry"
            :rules="[{  required: true,message: '请输入行业' }]"
            placeholder="请输入行业")
        van-field(
            label="省市区"
            readonly
            clickable
            :value="addressText"
            @click="showAddressPicker"
            placeholder="省市区")
        van-popup(v-model="showPicker" position="bottom")
            van-picker(
                value-key="label"
                ref="addressPicker"
                show-toolbar
                :columns="addressOptions"
                @cancel="showPicker = false"
                @confirm="onAddressConfirm"
                )
        van-field(
            label="详细地址"
            placeholder="精确到门牌号"
            :rules="[{ required: true, message: '请输入详细地址' }]"
            v-model="memberInfo.address.details")
        van-button(type="primary" round block style="margin:16px 0" native-type="submit") 更新
</template>

<script>
import { setStorage, getStorage } from '@/utils/localstorage.js'
import { getAddress, updateMember, getRecipients } from '@/service/member'

import { mapState, mapActions } from 'vuex'
import { isObject } from '@/utils/common'

export default {
    data() {
        return {
            addressOptions: [],
            showPicker: false,
        }
    },
    computed: {
        ...mapState(['memberInfo']),
        addressText() {
            if (this.memberInfo.address.province) {
                const { province, city, district } = this.memberInfo.address
                return `${province ?? ''} ${city ?? ''} ${district ?? ''}`
            }
            return ''
        },
    },
    methods: {
        ...mapActions(['getMemberInfo']),
        showAddressPicker() {
            this.showPicker = true
            this.$nextTick(() => {
                const { province, city, district } = this.memberInfo.address
                this.$refs.addressPicker.setValues([province, city, district])
            })
        },
        validatePhone(value) {
            return /^1[345789]\d{9}$/.test(value)
        },
        validateMail(value) {
            return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)
        },
        async onAddressConfirm(address) {
            this.$set(this.memberInfo, 'address', this.processAddress(address))
            this.showPicker = false
        },
        processAddress(addressArr) {
            let ks = ['province', 'city', 'district']
            let address = {}
            ks.forEach((k, i) => {
                address[k] = addressArr[i] || ''
            })
            return address
        },
        getFieldsValue(form, userInfo) {
            for (let k in form) {
                if (isObject(form[k])) {
                    this.getFieldsValue(form[k], userInfo[k])
                } else {
                    form[k] = userInfo[k]
                }
            }
            return form
        },
        async confirm() {
            try {
                await updateMember(this.memberInfo)
                this.$message.success('更新成功')
                this.getMemberInfo()
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        async getAddressOptions() {
            // 获取全部省市
            let address = getStorage('ms_address_info')
            if (!(Array.isArray(address) && address.length > 0)) {
                address = this.appendChildren(await getAddress())

                setStorage('ms_address_info', address)
            }

            return address
        },
        // 保持级联层数都为3
        appendChildren(data) {
            return data.map((item) => {
                if (item.children.length > 0) {
                    item.children = item.children.map((value) => {
                        if (!value.children?.length)
                            value.children = [{ label: '' }]
                        return value
                    })
                } else {
                    item.children = [{ label: '', children: [{ label: '' }] }]
                }
                return item
            })
        },
        async setByRecipient(u) {
            if (
                !(
                    u.personName.firstName &&
                    u.phone &&
                    Object.keys(u.address).length > 3
                )
            ) {
                const rs = await getRecipients()
                if (!rs.data.length) return
                const v = rs.data[0]
                let address =
                    Object.keys(u.address).length -
                        Object.keys(v.address).length >=
                    0
                        ? u.address
                        : v.address
                u.personName.firstName = u.personName.firstName || v.personName
                u.phone = u.phone || v.phone
                u.addressArr = this.address2AddressArr(address)
            }
        },
        address2AddressArr(address) {
            if (address) {
                let ks = ['province', 'city', 'district'],
                    addressArr = []

                ks.forEach((k, i) => {
                    addressArr[i] = address[ks[i]]
                })
                return addressArr
            }
        },
    },
    async created() {
        this.addressOptions = await this.getAddressOptions()
    },
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin.less';
.new-address-container {
    padding: @spacing;
}
</style>
